import React, { useState } from "react";
import { Typography } from "@material-tailwind/react";
import Contact from "../pages/ContactDialog";
import { useUserSession } from "../../lib/session/UserSession";

export default function Footer({ className = "" }) {
  const [showContactUs, setShowContactUs] = useState(false);
  const { sessionStore } = useUserSession();
  const appMeta = {
    ...sessionStore.APP_META.APPLICATION,
  };

  return (
    <footer
  className={`pl-2 pr-2 z-10 w-full flex flex-row items-center justify-between py-1 text-sm bg-gray-900 ${className}`}
>
  {/* Left Side - About Us */}
  <div>
    <Typography
      as="a"
      href="/about"
      color="white"
      className="font-normal transition-colors hover:text-blue-500 focus:text-blue-500"
    >
      About Us
    </Typography>
  </div>

  {/* Right Side - Contact Us */}
  <div>
    <Typography
      onClick={() => setShowContactUs(!showContactUs)}
      color="white"
      className="font-normal transition-colors hover:text-blue-500 focus:text-blue-500 rounded-2xl hover:cursor-pointer"
    >
      Contact Us
    </Typography>
    <Contact showContactUs={showContactUs} setShowContactUs={setShowContactUs} />
  </div>
</footer>
  );
}
